import React from 'react';

import { useGroupState } from './GroupContext';
import PermissionBlock from './PermissionBlock';

import styles from './PermissionsSection.module.scss';

const PermissionsSection = () => {
  const state = useGroupState();
  const permissions = state?.permissions;

  if (!permissions) return null;

  return (
    <div className={styles.permissionsSection}>
      <h3 className={styles.sectionTitle}>Permissions</h3>
      <p className={styles.sectionDescription}>
        Manage who can perform specific actions within this group. Roles grant permissions automatically. You can also grant permissions directly to individual members.
      </p>
      <div className={styles.permissionBlocks}>
        {permissions.map((permission) => (
          <PermissionBlock key={permission.actionName} permission={permission} />
        ))}
      </div>
    </div>
  );
};

export default PermissionsSection;
